<template>
  <vs-row>
    <form>
      <vs-row vs-type="flex">
        <vs-col vs-lg="6" vs-sm="12">
          <vs-input label="Étel név (kötelező)" v-model="dItem.ItemName"></vs-input>
          <vs-input type="number" label="Étel ár (kötelező)" v-model="dItem.ItemPrice"></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="justify-content-center saveButton">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés
        </vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "new_daily_item_quick",
  data() {
    return {
      dItem: {
        ItemName: '',
        ItemPrice: 0
      }
    }
  },
  methods: {
    save() {
      let self = this;
      let url = 'admin/dailyMenuItemController.php?action=new';
      let form = new FormData();


      form.append('itemData', JSON.stringify(self.dItem));

      axiosInstance({
        method: 'post',
        url: url,
        data: form,
        headers: {'Content-Type': 'multipart/form-data'},
      }).then((resp) => {
        self.$vs.notify({
          title: 'Rendszerüzenet',
          position: 'top-right',
          text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
          color: resp.data.status === 'OK' ? 'success' : 'danger',
          icon: resp.data.status === 'OK' ? 'check_box' : 'error'
        });
        self.dItem.ItemName = '';
        self.dItem.ItemPrice = 0;
        self.$parent.$emit('closemodal');
      })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    isNotSaveable() {
      return !this.dItem.ItemName || !Number.isInteger(parseInt(this.dItem.ItemPrice));
    }
  }
}
</script>

<style scoped>
.con-vs-checkbox {
  margin-top: 15px;
}

.vs-input, .con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}

label {
  text-align: center;
}

.itemImage {
  border: 1px solid #ccc;
  width: 270px;
  height: 190px;
  overflow: hidden;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  background-size: cover;
}
</style>